import type { DetailEntryState } from '../../useSharedElementTransition'

export const EN_DASH = '–'

// Meta line: `{n} players · est. {year}`. The global league has no est. year (it predates every
// account), so it drops the segment entirely.
export function formatMetaLine(
  memberCount: number,
  estYear?: number | null
): string {
  const players = `${memberCount.toLocaleString()} players`
  return estYear != null ? `${players} · est. ${estYear}` : players
}

// Movement delta as an arrowed magnitude — the sign lives in the arrow, never in the number.
export function formatRankDelta(delta: number): string {
  return delta > 0 ? `↑${delta}` : `↓${Math.abs(delta)}`
}

// Enter/exit transition state → root modifier. `entering` hides the real header
// name (the clone is flying) and holds content pre-stagger; `settled` reveals the name and
// staggers content in; `leaving` fades content out for the collapse; the crossfade states fade the
// whole route for the reduced-motion / degenerate-rect fallback.
const ENTRY_MODIFIERS: Record<DetailEntryState, string> = {
  idle: '',
  entering: 'league-detail--entering',
  settled: 'league-detail--settled',
  leaving: 'league-detail--leaving',
  'crossfade-in': 'league-detail--crossfade-in',
  'crossfade-out': 'league-detail--crossfade-out',
}

// Root class for the route, including the transition modifier when one applies. `idle` (and any
// unknown state) renders the bare class so a normally-entered route carries no transition CSS.
export function leagueDetailRootClass(state: DetailEntryState = 'idle'): string {
  const modifier = ENTRY_MODIFIERS[state] ?? ''
  return modifier ? `league-detail ${modifier}` : 'league-detail'
}
